// Import model
import { FilterNoteRequest } from '../models/FilterNoteRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { NoteCondition } from '../models/NoteCondition';
import { NoteFields } from '../models/NoteFields';
import { NoteIndexedFields } from '../models/NoteIndexedFields';

// Import dependency serializers (for complex types)
import { NoteConditionSerializer } from './NoteConditionSerializer';
import { NoteFieldsSerializer } from './NoteFieldsSerializer';
import { NoteIndexedFieldsSerializer } from './NoteIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterNoteRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterNoteRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterNoteRequest instance
   */
  static deserialize(json: string): FilterNoteRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterNoteRequest instance
   */
  static fromObject(obj: any): FilterNoteRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterNoteRequest');
    }


    const instance: FilterNoteRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as NoteIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as NoteFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        NoteConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterNoteRequest instances
   */
  static deserializeArray(json: string): FilterNoteRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterNoteRequest instance to a JSON string
   */
  static serialize(instance: FilterNoteRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterNoteRequest instance to a plain object
   */
  static toObject(instance: FilterNoteRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        NoteConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterNoteRequest instances to a JSON string
   */
  static serializeArray(instances: FilterNoteRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
